const crescendoLinks = new Swiper('#crescendo-links-swiper', {
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1,
    breakpoints: {
      540: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      900: {
        slidesPerView: 4,
      },
    },
  });

  const crescendoSlide = new Swiper('#crescendo-slide-swiper', {
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1,
    breakpoints: {
      1000: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
    themeColor: '#cdcdcd'
  });

  const crescendoEsperts = new Swiper('#crescendo-experts-swiper', {
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    slidesPerView: 1,
    breakpoints: {
      540: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      900: {
        slidesPerView: 4,
      },
    },
  });

  const crescendoRelated = new Swiper('#crescendo-related-swiper', {
    direction: 'horizontal',
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    slidesPerView: 1,
    breakpoints: {
      540: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      900: {
        slidesPerView: 4,
      },
    },
  });

  crescendoSlide.on('slideChange', function () {
    var title = crescendoSlide.slides[crescendoSlide.activeIndex].getAttribute('data-crescendo-title');
    var subtitle = crescendoSlide.slides[crescendoSlide.activeIndex].getAttribute('data-crescendo-subtitle');
    document.getElementById('crescendo-slider-title').innerHTML = title;
    document.getElementById('crescendo-slider-subtitle').innerHTML = subtitle;
  });

  $('[data-reading-time]').each(function(){
    var text = $($(this).attr('data-reading-time')).text();
    var wpm = 225;
    var words = text.trim().split(/\s+/).length;
    var time = Math.ceil(words / wpm);
    $(this).text(time);
  });